import { AutoAwesome } from '@mui/icons-material';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import { useSetRecoilState } from 'recoil';
import { workflowModalState } from '~/state/atoms/viewerAtoms';

export function ActionDropdown() {
    const setWorkflowModal = useSetRecoilState(workflowModalState);

    return (
        <Box>
            <Button
                fullWidth
                variant="outlined"
                size="small"
                onClick={() =>
                    setWorkflowModal((state) => ({
                        ...state,
                        open: true,
                    }))
                }
                sx={{
                    textTransform: 'capitalize',
                    borderColor: 'primary.light',
                    color: 'primary.light',
                }}
            >
                <AutoAwesome
                    sx={{
                        position: 'absolute',
                        left: 8,
                        marginRight: 1,
                        fontSize: 16,
                    }}
                />
                AI assistant
            </Button>
        </Box>
    );
}
